export const threeDotsIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
        <circle class="dots" cx="10.0008" cy="10.0008" r="1.42857" fill="white"/>
        <circle class="dots" cx="10.0008" cy="14.286" r="1.42857" fill="white"/>
        <circle class="dots" cx="10.0008" cy="5.71373" r="1.42857" fill="white"/>
    </g>
</svg>
`